import { useDebug as E, Event as c, Icon as B, ActiveAlarm as f, logger as V, defineListFields as N, useList as z, SortDirection as A, Device as v, Badge as F, Upload as L, PageLayout as P, PageContainer as j, Auth as R, Version as U } from "@evac/shared";
import { useSubject as H } from "@vueuse/rxjs";
import { defineComponent as $, createElementBlock as b, openBlock as i, Fragment as G, createVNode as t, createBlock as C, createCommentVNode as y, unref as e, withCtx as o, createElementVNode as a, createTextVNode as O, toDisplayString as p, computed as I, ref as q, normalizeStyle as J, normalizeClass as k, renderSlot as K } from "vue";
import * as Q from "rxjs";
import { useI18n as S } from "vue-i18n";
const W = {
  type: "button",
  class: "btn"
}, X = {
  type: "button",
  class: "btn"
}, Y = /* @__PURE__ */ $({
  __name: "DebugActions",
  setup(r) {
    const { t: n } = S({ useScope: "global" }), { enabled: s } = E();
    return (l, u) => (i(), b(G, null, [
      t(e(c).TriggerDialog, null, {
        trigger: o(() => [
          a("button", W, [
            t(e(B), {
              icon: e(c).ICON
            }, null, 8, ["icon"]),
            O(" " + p(e(n)("event.dialog.trigger", "Trigger Event")), 1)
          ])
        ]),
        _: 1
      }),
      e(s) ? (i(), C(e(f).Dialog, { key: 0 }, {
        trigger: o(() => [
          a("button", X, [
            t(e(B), {
              icon: e(f).ICON
            }, null, 8, ["icon"]),
            O(" " + p(e(n)("alarm.dialog.run")), 1)
          ])
        ]),
        _: 1
      })) : y("", !0)
    ], 64));
  }
}), Z = new Q.BehaviorSubject(null);
function M() {
  const r = H(Z, { onError: V.error });
  function n(l) {
    return I(() => r.value === l);
  }
  function s(l) {
    r.value = l;
  }
  return {
    highlightedDevice: r,
    isHighlighted: n,
    highlightDevice: s
  };
}
const ee = { class: "grid grid-rows-[max-content_minmax(0,1fr)] min-h-0 min-w-0" }, te = { class: "grid gap-2 pt-4 pb-2 px-2" }, oe = { class: "flex gap-4 items-center" }, se = { class: "headline" }, ne = {
  key: 0,
  class: "paragraph p-4 text-center text-muted col-span-full"
}, le = /* @__PURE__ */ $({
  __name: "DevicesTable",
  setup(r) {
    const { t: n } = S({
      messages: {
        en: {
          devicesOverview: "Devices Overview"
        },
        cs: {
          devicesOverview: "Přehled zařízení"
        }
      }
    }), { t: s } = S({ useScope: "global" }), { enabled: l } = E(), { highlightedDevice: u, highlightDevice: d } = M(), x = N(
      { key: "name", fill: !0 },
      { key: "uuid", visible: () => l.value },
      { key: "mac", visible: () => l.value },
      { key: "room" },
      { key: "battery" },
      { key: "rssi" },
      { key: "scanner" },
      { key: "lastActivity" }
    ), { sort: g } = z({ initialSort: { key: "roomName", direction: A.enum.Ascending }, fields: x }), h = q(v.useDisplayFilters()), { count: m, list: D } = v.useDisplayState({ sort: () => [g.value, v.DEFAULT_SORT], filter: h });
    return (de, w) => (i(), b("section", ee, [
      a("header", te, [
        a("div", oe, [
          a("h1", se, p(e(n)("devicesOverview")), 1),
          t(e(F), null, {
            default: o(() => [
              O(p(e(m)), 1)
            ]),
            _: 1
          })
        ]),
        t(e(v).Filters, {
          modelValue: h.value,
          "onUpdate:modelValue": w[0] || (w[0] = (_) => h.value = _),
          "hide-enabled": ""
        }, null, 8, ["modelValue"])
      ]),
      t(e(v).List, {
        class: "overflow-y-auto [scrollbar-gutter:stable]",
        devices: e(D)
      }, {
        item: o(({ device: _, rowStyle: T }) => [
          t(e(v).Row, {
            class: k(["transition-colors hover:bg-emphasis-1", {
              "bg-accent-orange/25": e(u) === _.uuid,
              "text-muted": !_.room
            }]),
            style: J(T),
            device: _,
            onMouseover: () => e(d)(_.uuid),
            onMouseout: w[1] || (w[1] = () => e(d)(null))
          }, null, 8, ["class", "style", "device", "onMouseover"])
        ]),
        default: o(() => [
          e(D).length ? y("", !0) : (i(), b("p", ne, p(e(s)("device.filter.empty")), 1))
        ]),
        _: 1
      }, 8, ["devices"])
    ]));
  }
}), ie = {
  key: 0,
  class: "container-type-size"
}, ae = ["src"], pe = /* @__PURE__ */ $({
  __name: "PlanImage",
  setup(r) {
    const { all: n } = L.useState(), s = I(() => n.value.at(0));
    return (l, u) => s.value ? (i(), b("div", ie, [
      a("img", {
        src: s.value.path,
        alt: "Floor plan",
        class: "rounded-xl shadow-md aspect-349/166 h-full mx-auto object-cover"
      }, null, 8, ae)
    ])) : y("", !0);
  }
}), re = {
  key: 0,
  class: "first:pt-4 flex flex-col gap-4 content-start max-w-1/3"
}, ce = { class: "headline px-2 pt-4" }, ue = /* @__PURE__ */ $({
  __name: "Basic",
  setup(r) {
    const { t: n } = S({ useScope: "global" }), { dashboard: s } = c.useState(), { highlightedDevice: l, highlightDevice: u } = M();
    return (d, x) => (i(), C(e(P), null, {
      nav: o(() => [
        t(e(Y))
      ]),
      footer: o(() => [
        t(e(U).Info)
      ]),
      "nav:post": o(() => [
        t(e(R).LogoutButton)
      ]),
      default: o(() => [
        t(e(f).Root, null, {
          default: o(({ detail: g, isAlarm: h }) => [
            t(e(j), {
              class: k(["p-4 gap-8 flex", { "border-4 border-accent-red": h }])
            }, {
              default: o(() => [
                a("div", {
                  id: "device-overview",
                  class: k(["grid grow gap-4 min-h-0 min-w-0", {
                    "grid-rows-[minmax(0,1fr)_minmax(0,1fr)]": d.$slots.image,
                    "grid-rows-[minmax(0,1fr)]": !d.$slots.image
                  }])
                }, [
                  t(e(le)),
                  K(d.$slots, "image")
                ], 2),
                e(s).length || g ? (i(), b("section", re, [
                  a("h2", ce, p(e(n)("events.title")), 1),
                  t(e(c).Cards, {
                    class: "grow grid gap-2 grid-cols-[repeat(auto-fill,minmax(16rem,1fr))] overflow-y-auto content-start p-2",
                    events: e(s)
                  }, {
                    event: o(({ event: m }) => [
                      t(e(c).Root, {
                        uuid: m.uuid
                      }, {
                        default: o(({ device: D }) => [
                          t(e(c).Dialog, { detail: m }, {
                            default: o(() => [
                              t(e(c).Card, {
                                class: k({ "btn-accent-orange": e(l) === m.device }),
                                event: m,
                                onMouseover: () => e(u)(D?.uuid ?? null),
                                onMouseout: x[0] || (x[0] = () => e(u)(null))
                              }, null, 8, ["class", "event", "onMouseover"])
                            ]),
                            _: 2
                          }, 1032, ["detail"])
                        ]),
                        _: 2
                      }, 1032, ["uuid"])
                    ]),
                    _: 1
                  }, 8, ["events"]),
                  g ? (i(), C(e(f).Message, {
                    key: 0,
                    class: "align-self-end max-h-1/2",
                    detail: g
                  }, {
                    actions: o(() => [
                      t(e(f).Actions, { detail: g }, null, 8, ["detail"])
                    ]),
                    _: 2
                  }, 1032, ["detail"])) : y("", !0)
                ])) : y("", !0)
              ]),
              _: 2
            }, 1032, ["class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), he = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Basic: ue
}, Symbol.toStringTag, { value: "Module" }));
export {
  Y as DebugActions,
  le as DevicesTable,
  pe as PlanImage,
  M as useHighlightedDevice,
  he as views
};
//# sourceMappingURL=index.js.map
